// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { z as zod } from 'zod';

/**
 * Create a course
 * @summary Create Course
 */
export const createCourseBody = zod
  .object({
    title: zod.string(),
    description: zod.string().optional(),
    ects: zod.number().optional(),
    language: zod.string().optional(),
    externalProductId: zod.string().or(zod.null()).optional(),
    segments: zod
      .array(
        zod
          .object({
            id: zod.string().or(zod.null()).optional(),
            title: zod.string(),
            sortIndex: zod.number().optional(),
            moduleIds: zod.array(zod.string()).optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
  })
  .strict();

export const createCourseResponse = zod
  .object({
    data: zod
      .object({
        title: zod.string(),
        description: zod.string().optional(),
        ects: zod.number().optional(),
        language: zod.string().optional(),
        externalProductId: zod.string().or(zod.null()).optional(),
        segments: zod
          .array(
            zod
              .object({
                id: zod.string().or(zod.null()).optional(),
                title: zod.string(),
                sortIndex: zod.number().optional(),
                moduleIds: zod.array(zod.string()).optional(),
              })
              .strict(),
          )
          .or(zod.null())
          .optional(),
        id: zod.string(),
        state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
        isDeprecated: zod.boolean().optional(),
        stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
        modules: zod
          .array(
            zod
              .object({
                moduleId: zod.string().or(zod.null()).optional(),
                sortIndex: zod.number().or(zod.null()).optional(),
                allowPartialSubmission: zod.boolean().or(zod.null()).optional(),
                ects: zod.number().or(zod.null()).optional(),
                learningHours: zod.number().or(zod.null()).optional(),
                examTaskIds: zod.array(zod.string()).or(zod.null()).optional(),
                segmentId: zod.string().or(zod.null()).optional(),
                enabledEventKinds: zod.array(zod.string()).or(zod.null()).optional(),
                mandates: zod
                  .object({
                    evaluation: zod
                      .object({
                        id: zod.string().or(zod.null()).optional(),
                        title: zod.string().or(zod.null()).optional(),
                      })
                      .strict()
                      .or(zod.null())
                      .optional(),
                    events: zod
                      .record(
                        zod.string(),
                        zod
                          .object({
                            id: zod.string().or(zod.null()).optional(),
                            title: zod.string().or(zod.null()).optional(),
                          })
                          .strict(),
                      )
                      .optional(),
                  })
                  .strict()
                  .or(zod.null())
                  .optional(),
                title: zod.string().or(zod.null()).optional(),
                authorName: zod.string().or(zod.null()).optional(),
                version: zod.string().or(zod.null()).optional(),
                state: zod.string().or(zod.null()).optional(),
              })
              .strict(),
          )
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Get list of all courses
 * @summary Get Courses
 */
export const getAllCoursesQueryParams = zod.object({
  state: zod.coerce.string().or(zod.null()).optional(),
  page: zod.coerce.number().optional(),
  pageSize: zod.coerce.number().optional(),
  sort: zod.coerce.string().optional(),
  filter: zod.coerce.string().optional(),
});

export const getAllCoursesResponse = zod
  .object({
    data: zod
      .array(
        zod
          .object({
            title: zod.string(),
            description: zod.string().optional(),
            ects: zod.number().optional(),
            language: zod.string().optional(),
            externalProductId: zod.string().or(zod.null()).optional(),
            segments: zod
              .array(
                zod
                  .object({
                    id: zod.string().or(zod.null()).optional(),
                    title: zod.string(),
                    sortIndex: zod.number().optional(),
                    moduleIds: zod.array(zod.string()).optional(),
                  })
                  .strict(),
              )
              .or(zod.null())
              .optional(),
            id: zod.string(),
            state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
            isDeprecated: zod.boolean().optional(),
            stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
            modules: zod
              .array(
                zod
                  .object({
                    moduleId: zod.string().or(zod.null()).optional(),
                    sortIndex: zod.number().or(zod.null()).optional(),
                    allowPartialSubmission: zod.boolean().or(zod.null()).optional(),
                    ects: zod.number().or(zod.null()).optional(),
                    learningHours: zod.number().or(zod.null()).optional(),
                    examTaskIds: zod.array(zod.string()).or(zod.null()).optional(),
                    segmentId: zod.string().or(zod.null()).optional(),
                    enabledEventKinds: zod.array(zod.string()).or(zod.null()).optional(),
                    mandates: zod
                      .object({
                        evaluation: zod
                          .object({
                            id: zod.string().or(zod.null()).optional(),
                            title: zod.string().or(zod.null()).optional(),
                          })
                          .strict()
                          .or(zod.null())
                          .optional(),
                        events: zod
                          .record(
                            zod.string(),
                            zod
                              .object({
                                id: zod.string().or(zod.null()).optional(),
                                title: zod.string().or(zod.null()).optional(),
                              })
                              .strict(),
                          )
                          .optional(),
                      })
                      .strict()
                      .or(zod.null())
                      .optional(),
                    title: zod.string().or(zod.null()).optional(),
                    authorName: zod.string().or(zod.null()).optional(),
                    version: zod.string().or(zod.null()).optional(),
                    state: zod.string().or(zod.null()).optional(),
                  })
                  .strict(),
              )
              .optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Get single courses
 * @summary Get Course
 */
export const getCourseParams = zod
  .object({
    course_id: zod.coerce.string(),
  })
  .strict();

export const getCourseResponse = zod
  .object({
    data: zod
      .object({
        title: zod.string(),
        description: zod.string().optional(),
        ects: zod.number().optional(),
        language: zod.string().optional(),
        externalProductId: zod.string().or(zod.null()).optional(),
        segments: zod
          .array(
            zod
              .object({
                id: zod.string().or(zod.null()).optional(),
                title: zod.string(),
                sortIndex: zod.number().optional(),
                moduleIds: zod.array(zod.string()).optional(),
              })
              .strict(),
          )
          .or(zod.null())
          .optional(),
        id: zod.string(),
        state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
        isDeprecated: zod.boolean().optional(),
        stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
        modules: zod
          .array(
            zod
              .object({
                moduleId: zod.string().or(zod.null()).optional(),
                sortIndex: zod.number().or(zod.null()).optional(),
                allowPartialSubmission: zod.boolean().or(zod.null()).optional(),
                ects: zod.number().or(zod.null()).optional(),
                learningHours: zod.number().or(zod.null()).optional(),
                examTaskIds: zod.array(zod.string()).or(zod.null()).optional(),
                segmentId: zod.string().or(zod.null()).optional(),
                enabledEventKinds: zod.array(zod.string()).or(zod.null()).optional(),
                mandates: zod
                  .object({
                    evaluation: zod
                      .object({
                        id: zod.string().or(zod.null()).optional(),
                        title: zod.string().or(zod.null()).optional(),
                      })
                      .strict()
                      .or(zod.null())
                      .optional(),
                    events: zod
                      .record(
                        zod.string(),
                        zod
                          .object({
                            id: zod.string().or(zod.null()).optional(),
                            title: zod.string().or(zod.null()).optional(),
                          })
                          .strict(),
                      )
                      .optional(),
                  })
                  .strict()
                  .or(zod.null())
                  .optional(),
                title: zod.string().or(zod.null()).optional(),
                authorName: zod.string().or(zod.null()).optional(),
                version: zod.string().or(zod.null()).optional(),
                state: zod.string().or(zod.null()).optional(),
              })
              .strict(),
          )
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Update a course
 * @summary Update Course
 */
export const updateCourseParams = zod
  .object({
    course_id: zod.coerce.string(),
  })
  .strict();

export const updateCourseBody = zod
  .object({
    title: zod.string(),
    description: zod.string().optional(),
    ects: zod.number().optional(),
    state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
    isDeprecated: zod.boolean().or(zod.null()).optional(),
    externalProductId: zod.string().or(zod.null()).optional(),
    segments: zod
      .array(
        zod
          .object({
            id: zod.string().or(zod.null()).optional(),
            title: zod.string(),
            sortIndex: zod.number().optional(),
            moduleIds: zod.array(zod.string()).optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
  })
  .strict();

export const updateCourseResponse = zod
  .object({
    data: zod
      .object({
        title: zod.string(),
        description: zod.string().optional(),
        ects: zod.number().optional(),
        language: zod.string().optional(),
        externalProductId: zod.string().or(zod.null()).optional(),
        segments: zod
          .array(
            zod
              .object({
                id: zod.string().or(zod.null()).optional(),
                title: zod.string(),
                sortIndex: zod.number().optional(),
                moduleIds: zod.array(zod.string()).optional(),
              })
              .strict(),
          )
          .or(zod.null())
          .optional(),
        id: zod.string(),
        state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
        isDeprecated: zod.boolean().optional(),
        stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
        modules: zod
          .array(
            zod
              .object({
                moduleId: zod.string().or(zod.null()).optional(),
                sortIndex: zod.number().or(zod.null()).optional(),
                allowPartialSubmission: zod.boolean().or(zod.null()).optional(),
                ects: zod.number().or(zod.null()).optional(),
                learningHours: zod.number().or(zod.null()).optional(),
                examTaskIds: zod.array(zod.string()).or(zod.null()).optional(),
                segmentId: zod.string().or(zod.null()).optional(),
                enabledEventKinds: zod.array(zod.string()).or(zod.null()).optional(),
                mandates: zod
                  .object({
                    evaluation: zod
                      .object({
                        id: zod.string().or(zod.null()).optional(),
                        title: zod.string().or(zod.null()).optional(),
                      })
                      .strict()
                      .or(zod.null())
                      .optional(),
                    events: zod
                      .record(
                        zod.string(),
                        zod
                          .object({
                            id: zod.string().or(zod.null()).optional(),
                            title: zod.string().or(zod.null()).optional(),
                          })
                          .strict(),
                      )
                      .optional(),
                  })
                  .strict()
                  .or(zod.null())
                  .optional(),
                title: zod.string().or(zod.null()).optional(),
                authorName: zod.string().or(zod.null()).optional(),
                version: zod.string().or(zod.null()).optional(),
                state: zod.string().or(zod.null()).optional(),
              })
              .strict(),
          )
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Delete a course
 * @summary Delete Course
 */
export const deleteCourseParams = zod
  .object({
    course_id: zod.coerce.string(),
  })
  .strict();

export const deleteCourseResponse = zod.any();
